import React from "react";
import pencilIcon from "../../assets/icons/pencilBig.svg";
import Image from "next/image";
import { motion } from "motion/react";

type MarketingFlashcardProps = {
  text: string;
  color: string;
};

const MarketingFlashcard = ({ text, color }: MarketingFlashcardProps) => {
  return (
    <>
      {/* text container */}
      <motion.div
        className="w-[280px] sm:w-[200px] md:w-[260px] 2xl:w-[400px] rounded-[20px] sm:rounded-[32px] p-3 sm:p-5 border-[1px] border-black border-dashed  shadow-none transition-shadow duration-300"
        style={{
          backgroundColor: color,
        }}
        whileHover={{
          scale: 1.05,
          rotate: -3,
          y: -10,
          boxShadow: "0 10px 30px -10px rgba(0,0,0,0.15)",
          transition: { duration: 0.3 },
        }}
      >
        {/* banner */}
        <p className="font-normal text-[6px] sm:text-[8px] text-black/70">
          SwiftStudy
        </p>
        {/* text box */}
        <p className="font-editorial text-sm lg:text-lg 2xl:text-xl font-bold text-black tracking-tight mt-1">
          {text}
        </p>
        {/* pencil icon */}
        <Image
          src={pencilIcon}
          alt="pencil icon"
          className="mt-2 sm:mt-4 w-8 sm:w-auto rotate-[18deg]"
        />
      </motion.div>
    </>
  );
};

export default MarketingFlashcard;
